import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getCarSerial } from '../../../../../../../services/api';

class RelatedRead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    state = {
        relatedArticleData: [],
    };

    async componentDidMount() {
        try {
            if (this.props.content[0].serialId) {
                const relatedArticleData = (await getCarSerial(this.props.content[0].serialId)).relatedArticleData;

                this.setState({
                    relatedArticleData,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { content } = this.props;
        const { relatedArticleData } = this.state;

        return (
            <div>
                {relatedArticleData.length >= 4 ? (
                    <div className={styles.relate_read}>
                        <div className={styles.arl_h4}>
                            <h4>相关阅读</h4>
                        </div>
                        <div className={styles.r_t_t}>
                            <ul>
                                {relatedArticleData.map((item, index) => (
                                    <li key={index}>
                                        <a href={item.url} target="_blank" rel={rel} className={styles.pic}>
                                            <img src={item.img} width="140" height="100" />
                                        </a>
                                        <a href={item.url} target="_blank" rel={rel} className={styles.txt}>
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(RelatedRead);
